import "./talks.css";
import React, { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { server, truncateText } from "../../common";
import { AxiosError } from "axios";
import configContext from "../../context/configContext/configContext";

const Talks = () => {
  document.title = "Talks";
  const [talks, setTalks] = useState([]);
  const [industrytalks, setIndustryTalks] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  useEffect(() => {
    getData();
    getIndustryData();
  }, []);

  // Get
  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/talk/getalltalks", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setTalks(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // industry
  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/talk/getallind_talk", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryTalks(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/talk/searchalltalk?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setTalks(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/talk/filter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setTalks(response.data);
          setIndustryTalks(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterCategoryData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/talk/searchalltalk?search=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setTalks(response.data);
          setIndustryTalks(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // const talks = [
  //   {
  //     id: 1,
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1701345884226699.jpg",
  //     title:
  //       "Tune in to 107th Episode of Mann Ki Baat by Prime Minister Narendra Modi on 26th November 2023",
  //     desc: "Tune in to 105th Episode of mann ki baat ny prime miniter narendra modi on 24th septemner 2023",
  //   },
  //   {
  //     id: 2,
  //     img: "https://static.mygov.in/static/s3fs-public/mkbocttalk_1700469862.jpg",
  //     title:
  //       "Tune in to 106th Episode of Mann Ki Baat by Prime Minister Narendra Modi on 29th October 2023",
  //     desc: "Tune in to 104th Episode of mann ki baat ny prime miniter narendra modi on 24th septemner 2023",
  //   },
  //   {
  //     id: 3,
  //     img: "https://static.mygov.in/static/s3fs-public/mkbtalksept_1700469862.jpg",
  //     title:
  //       "Tune in to 105th Episode of Mann Ki Baat by Prime Minister Narendra Modi on 24th September 2023",
  //     desc: "Tune in to 103th Episode of mann ki baat ny prime miniter narendra modi on 24th septemner 2023",
  //   },
  //   {
  //     id: 4,
  //     img: "https://static.mygov.in/static/s3fs-public/talkmkbaugust_1700469862.jpg",
  //     title:
  //       "Tune in to 104th Episode of Mann Ki Baat by Prime Minister Narendra Modi on 27th August 2023",
  //     desc: " Tune in to 102th Episode of mann ki baat ny prime miniter narendra modi on 24th septemner 2023",
  //   },
  //   {
  //     id: 5,
  //     img: "https://static.mygov.in/static/s3fs-public/talkjuly_1700469862.jpg",
  //     title:
  //       "Tune in to 103rd Episode of Mann Ki Baat by Prime Minister Narendra Modi on 30th July 2023",
  //     desc: " Tune in to 102th Episode of mann ki baat ny prime miniter narendra modi on 24th septemner 2023",
  //   },
  // ];

  return (
    <>
      <div className="container-xl " style={{ marginTop: "1rem" }}>
        <h3 className="text-center my-3">Talks</h3>
        <div className="row my-3">
          <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterCategoryData(e)} // Pass the event to FilterData
            >
              <option value="industry">Industry</option>
              <option value="institute">Institute</option>
              <option value="university">University</option>
            </select>
          </div>
          <div className="col-md-4 my-1">
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-4 my-1">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Last 2 days
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
            </select>
          </div>
        </div>
        <div className="row ">
          {talks.map((item) => {
            return (
              <>
                <div className="col-md-4 my-2" key={item.id}>
                  <div
                    className="talk-item shadow card"
                    style={{ height: "31rem" }}
                  >
                    <img
                      className="card-img-top"
                      style={{ height: "16rem" }}
                      src={item.image}
                      alt=""
                    />
                    <div className="">
                      <p className="my-2 text-center">
                        <h5 className="text-dark p-2">
                          <NavLink to={`/talks/${item.id}`}>
                            {item.title}
                          </NavLink>
                        </h5>
                        <p>{truncateText(item.description, 20)}</p>
                      </p>

                      <div className="row p-2">
                        <div className="col">
                          <NavLink
                            to={`/talks/${item.id}`}
                            className="btn banner rounded-5 btn-sm w-100 text-text-decoration-none text-white"
                          >
                            Watch Now
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}

          {industrytalks
            .filter((item) => item.status === "Post")
            .map((item) => {
              return (
                <>
                  <div className="col-md-4 my-2" key={item.id}>
                    <div
                      className="talk-item shadow card"
                      style={{ height: "31rem" }}
                    >
                      <img
                        className="card-img-top"
                        style={{ height: "16rem" }}
                        src={item.image}
                        alt=""
                      />
                      <div className="">
                        <p className="my-2 text-center">
                          <h5 className="text-dark p-2">
                            <NavLink to={`/talks/${item.id}`}>
                              {item.title}
                            </NavLink>
                          </h5>
                          <p>{truncateText(item.description, 20)}</p>
                        </p>

                        <div className="row p-2">
                          <div className="col">
                            <NavLink
                              to={`/talks/${item.id}`}
                              className="btn banner rounded-5 btn-sm w-100 text-text-decoration-none text-white"
                            >
                              Watch Now
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Talks;
